import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Dialog, DialogContent, Typography, IconButton, useMediaQuery, useTheme } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { PERSONAL_ASSISTANT } from '../../consts';

export default function AssistentePessoal({ open, handleClickClose }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      display: "flex",
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    closeButton: {
      right: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other} >
        <IconButton className={classes.closeButton} onClick={(e) => handleClickClose(e)}>
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" style={{fontFamily: 'Public Sans', fontSize: '16px'}}>{children}</Typography>

        <div style={{ display: 'flex', gap: '10px', marginRight: '16px' }}>
          <div style={{ width: '30px', height: '16px', top: '24px', left: '613px', borderRadius: '4px', backgroundColor: '#47BEF3' }}></div>
          <div style={{ width: '30px', height: '16px', top: '24px', left: '613px', borderRadius: '4px', backgroundColor: '#F3C046' }}></div>
          <div style={{ width: '30px', height: '16px', top: '24px', left: '613px', borderRadius: '4px', backgroundColor: '#84D955' }}></div>
        </div>
      </MuiDialogTitle>
    );
  });

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      maxWidth="sm"
      fullWidth={true}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle style={{ color: '#727780'}}>
        PAE | Professor Assistente eduCAT
      </DialogTitle>
      <DialogContent dividers style={{ margin: '0', padding: '0' }}>
        <iframe src={PERSONAL_ASSISTANT} style={{ width: '100%', height: '568px', border: 'none' }} />
      </DialogContent>
    </Dialog>
  );
}